module.exports = __webpack_public_path__ + "img/no_data_banner.e6a8bd11.png";